import { render, staticRenderFns } from "./trainingSet.vue?vue&type=template&id=f526501e&scoped=true&"
import script from "./trainingSet.vue?vue&type=script&lang=js&"
export * from "./trainingSet.vue?vue&type=script&lang=js&"
import style0 from "./trainingSet.vue?vue&type=style&index=0&id=f526501e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f526501e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
